var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "page-header",
        {
          staticClass: "mt-4 mt-md-0 mt-sm-4 billing-history__page-header",
          attrs: {
            "left-side-class": "col-xl-4",
            page: _vm.pageHeaderConfig,
            "right-side-class":
              "col-xl-8 align-items-end d-flex pb-2 justify-content-end"
          }
        },
        [
          [
            !_vm.isShowingCreateInvoice && _vm.userHasPermissions("billing.add")
              ? _c("action-button", {
                  attrs: {
                    i: "fas fa-file-plus",
                    text: "Crear Factura",
                    variant: "success invoice-action"
                  },
                  on: { click: _vm.showCreateInvoice }
                })
              : _vm._e()
          ]
        ],
        2
      ),
      _vm.isShowingCreateInvoice
        ? _c("InvoiceForm", {
            attrs: {
              "academic-year-options": _vm.academicYears,
              "center-options": _vm.userCenters,
              "is-provider": _vm.isCompany,
              "month-options": _vm.monthOptionsToInvoiceCreation,
              "provider-options": _vm.providerOptionsToInvoiceCreation
            },
            on: {
              cancel: _vm.cancelInvoiceHandler,
              create: _vm.createInvoiceHandler
            },
            model: {
              value: _vm.create,
              callback: function($$v) {
                _vm.create = $$v
              },
              expression: "create"
            }
          })
        : _c("filter-manager", {
            ref: "filter",
            staticClass: "billing-history__filter-manager",
            attrs: { filters: _vm.filterManagerConfig },
            on: {
              academicYear: _vm.onChangeAcademicYear,
              search: _vm.onSearchHandler,
              serviceType: _vm.onChangeServiceType
            },
            model: {
              value: _vm.filter,
              callback: function($$v) {
                _vm.filter = $$v
              },
              expression: "filter"
            }
          }),
      _c("custom-separator", {
        staticClass: "pt-3 my-4",
        attrs: { text: "Resultado de Facturas" }
      }),
      _vm.pagination.results.length > 0
        ? _c(
            "div",
            _vm._l(_vm.pagination.results, function(item, index) {
              return _c("HistoryResultRow", {
                key: `billing-invoice-${index}`,
                attrs: {
                  id: item.billId,
                  "bill-number": item.billNumber,
                  "billing-status-date": item.billingStatusDate,
                  "billing-status-id": item.billingStatusId,
                  "billing-status-name": item.billingStatusName,
                  "can-cancel": _vm.hasCancelPermission(item.billingStatusId),
                  "center-name": item.centerName,
                  "company-name": item.companyName,
                  interventors: item.interventors,
                  "offered-service": item.offeredService,
                  period: item.period,
                  "total-bill-amount": item.totalBillAmount
                },
                on: {
                  cancel: _vm.onCancelResonSubmit,
                  enter: _vm.onEnterHandler
                }
              })
            }),
            1
          )
        : _vm._e(),
      _vm.showPagination
        ? _c("pagination", {
            attrs: { data: _vm.pagination, "show-text": "" },
            on: { "pagination-go-page": _vm.goToPage }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }